import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { map, isEmpty } from 'ramda';

import DataTable from 'components/ui/DataTable';
import NoTableData from 'components/NoTableData';

const ArrhythmiaHistoryTable = ({ data, t }) =>
  isEmpty(data) ? (
    <NoTableData />
  ) : (
    <DataTable>
      <thead>
        <tr>
          <td>{t('details')}</td>
          <td>{t('response')}</td>
        </tr>
      </thead>
      <tbody>
        {map(
          ({ title, value }) => (
            <tr key={title}>
              <td>
                <strong>{title}</strong>
              </td>
              <td>{value}</td>
            </tr>
          ),
          data,
        )}
      </tbody>
    </DataTable>
  );

ArrhythmiaHistoryTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ArrhythmiaHistoryTable);
